import { useState } from 'react';
import { Popover } from 'antd';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import { ExclamationCircleFilled } from '@ant-design/icons';

import { colorConstants } from 'config/colorConstants';

import { CustomCheckbox } from './PackArchitectureTable.styles';
import { TABLE_MIN_METRIC_SELECTION_MESSAGE } from './packArchitectureTable.helpers';
import type { KpiOption } from './packArchitectureTable.helpers';

type PackArchitectureTableKpiCheckboxProps = {
    option: KpiOption;
    isChecked: boolean;
    selectedKpiCount: number;
    onToggle: (kpiId: string) => void;
};

const MinMetricSelectionPopoverContent = ({ onClose }: { onClose: () => void }) => (
    <div className="w-[248px]">
        <div className="flex items-start gap-2">
            <ExclamationCircleFilled
                className="mt-0.5 shrink-0 text-base"
                style={{ color: colorConstants.growthDown }}
            />
            <span className="text-sm leading-[18px]" style={{ color: colorConstants.blackTitle }}>
                {TABLE_MIN_METRIC_SELECTION_MESSAGE}
            </span>
        </div>
        <div className="mt-3 flex justify-end">
            <button
                type="button"
                className="border-0 bg-transparent p-0 text-sm font-medium leading-[18px]"
                style={{ color: colorConstants.violet }}
                onClick={onClose}
            >
                Close
            </button>
        </div>
    </div>
);

export const PackArchitectureTableKpiCheckbox = ({
    option,
    isChecked,
    selectedKpiCount,
    onToggle,
}: PackArchitectureTableKpiCheckboxProps) => {
    const [showMinMetricPopover, setShowMinMetricPopover] = useState(false);

    const handleChange = (nextChecked: boolean) => {
        if (!nextChecked && isChecked && selectedKpiCount === 1) {
            setShowMinMetricPopover(true);
            return;
        }

        setShowMinMetricPopover(false);
        onToggle(option.id);
    };

    return (
        <Popover
            open={showMinMetricPopover}
            onOpenChange={setShowMinMetricPopover}
            placement="top"
            trigger={[]}
            content={<MinMetricSelectionPopoverContent onClose={() => setShowMinMetricPopover(false)} />}
            overlayInnerStyle={{ padding: 16, borderRadius: 8 }}
        >
            <span className="inline-flex">
                <CustomCheckbox
                    checked={isChecked}
                    onChange={(event: CheckboxChangeEvent) => handleChange(event.target.checked)}
                >
                    {option.label}
                </CustomCheckbox>
            </span>
        </Popover>
    );
};
